const React = require('react');
const ButtonBase = require('@material-ui/core/ButtonBase').default;


module.exports = ({
  disabled,
  children,
  className,
  component,
  ...props
}) => {
  return (
    <div
      className={'rlv '
        + (disabled ? 'disabled ' : '')
        + (className || '')}
    >
      {children}
      {disabled ? null : (<ButtonBase
        {...props}
        component={component || 'a'}
        className="dB*2 abs*2 s cr@mouse"
      />)}
    </div>
  );
};
